module.exports = __webpack_public_path__ + "img/hello.773c8b7f.png";